export const maidNationality = {
  BD: 'Bangladeshi',
  MM: 'Burmese',
  KH: 'Cambodian',
  PH: 'Filipino',
  HK: 'Hong Konger',
  IN: 'Indian',
  ID: 'Indonesian',
  MO: 'Macanese',
  MY: 'Malaysian',
  KR: 'South Korean',
  LK: 'Sri Lankan',
  TW: 'Taiwanese',
  TH: 'Thai'
}

export const workPermitType = {
  N: 'New',
  R: 'Renewal',
  T: 'Transfer'
}

export const paymentMode = {
  CC: 'Credit Card/Debit Card',
  CH: 'Cash/Cheque'
}

export const appNationality = {
  SG: 'Singaporean',
  SP: 'Singaporean PR',
  OT: 'Others'
}

export const gtNationality = {
  SG: 'Singaporean',
  SP: 'Singaporean PR'
}
